import { LicensePlan } from 'libs/callabo-state/types/License';

/** plan별 기능 제한 목적 */
export type PlanPolicyNames =
  | 'above_plus'
  | 'above_pro'
  | 'only_trial'
  | 'only_plus'
  | 'pro_with_trial';

export const PLAN_POLICY: Record<PlanPolicyNames, Record<LicensePlan, boolean>> = {
  above_plus: {
    trial: false,
    plus: true,
    pro: true,
  },
  above_pro: {
    trial: false,
    plus: false,
    pro: true,
  },
  only_trial: {
    trial: true,
    plus: false,
    pro: false,
  },
  only_plus: {
    trial: false,
    plus: true,
    pro: false,
  },
  pro_with_trial: {
    trial: true,
    plus: false,
    pro: true,
  },
};
